import { labelsEn } from './labels-en';
export const labelsTr = {
  ...labelsEn,
  title: 'Etiketler ve ürün işaretleme',
  subtitle: 'Onaylanmış ürün verilerinden sürümlü, çok dilli etiketler.',
  active: 'Etkin',
  inactive: 'Devre dışı',
  autoReleased: 'En son onaylı sürüm',
  help: { open: 'Etiket yardımını aç' },
  tabs: {
    templates: 'Şablonlar',
    formats: 'Formatlar',
    prints: 'Baskı geçmişi',
    design: 'Tasarım',
    previewPrint: 'Önizleme ve baskı',
  },
  templates: {
    title: 'Etiket şablonları',
    description: 'Etiket modu merkezi PDF tasarımcısını kullanır ve her onaylı sürümü dondurur.',
    create: 'Yeni şablon',
    createDescription: 'Doğrulanmış fiziksel format ve başlangıç düzeniyle başlayın.',
  },
  formats: {
    title: 'Etiket formatları',
    description: 'Sayfa, rulo, ızgara, kenar ve aralıkları milimetre olarak yapılandırın.',
    create: 'Yeni format',
    edit: 'Formatı düzenle',
  },
  prints: {
    title: 'Baskı geçmişi',
    description: 'DMS içindeki değiştirilemez test, üretim ve yeniden baskı kanıtları.',
  },
  designer: {
    subtitle: 'Şablon sürümü {{version}}',
    elements: 'Öğeler',
    canvas: 'Etiket alanı',
    inspector: 'Özellikler',
    selectElement: 'Düzenlemek için bir öğe seçin.',
  },
  preview: {
    title: 'Veri anlık görüntüsü',
    description:
      'Gerçek ERP kaynak verilerini seçin. Sunucu baskıda kullanılan aynı anlık görüntüyü doğrular ve oluşturur.',
    legalTitle: 'İnceleme gerekli',
    legalWarning:
      'Beyanlar ve yasal etiket içeriği bağlayıcı kullanımdan önce yetkin personel tarafından kontrol edilmeli ve açıkça onaylanmalıdır.',
    pdf: 'Sunucu PDF önizlemesi',
    empty: 'Verileri seçin ve bir önizleme oluşturun.',
  },
  fields: {
    ...labelsEn.fields,
    name: 'Ad',
    description: 'Açıklama',
    mediaType: 'Medya türü',
    active: 'Etkin',
    pageWidthMm: 'Sayfa genişliği (mm)',
    pageHeightMm: 'Sayfa yüksekliği (mm)',
    labelWidthMm: 'Etiket genişliği (mm)',
    labelHeightMm: 'Etiket yüksekliği (mm)',
    columns: 'Sütunlar',
    rows: 'Satırlar',
    marginLeftMm: 'Sol kenar (mm)',
    marginTopMm: 'Üst kenar (mm)',
    horizontalGapMm: 'Yatay aralık (mm)',
    verticalGapMm: 'Dikey aralık (mm)',
    format: 'Format',
    text: 'Metin',
    dynamicField: 'Dinamik veri alanı',
    analysisParameter: 'Analiz parametresi anahtarı',
    symbology: 'Barkod sembolojisi',
    valueTemplate: 'Değer şablonu',
    gs1Segments: 'GS1 bölümleri',
    gs1Hint: 'Biçim: AI:kaynak:sabit uzunluk, ör. 01:product.number:14, 10:batch.number',
    xMm: 'X (mm)',
    yMm: 'Y (mm)',
    widthMm: 'Genişlik (mm)',
    heightMm: 'Yükseklik (mm)',
    rotation: 'Döndürme',
    fontSize: 'Yazı boyutu (pt)',
    bold: 'Kalın',
    product: 'Ürün',
    batch: 'Parti',
    productionOrder: 'Üretim emri',
    declaration: 'Beyan',
    analysis: 'Analiz / besin',
    quantity: 'Miktar',
    unit: 'Birim',
    copies: 'Kopya',
    reason: 'Gerekçe',
    note: 'İnceleme notu',
    languages: 'Diller',
  },
  columns: {
    ...labelsEn.columns,
    name: 'Ad',
    version: 'Sürüm',
    format: 'Format',
    status: 'Durum',
    updated: 'Güncellendi',
    page: 'Sayfa',
    grid: 'Izgara',
    number: 'Baskı no.',
    product: 'Ürün / parti',
    template: 'Şablon',
    kind: 'Tür',
    created: 'Oluşturuldu',
    actions: 'İşlemler',
  },
  media: { SHEET: 'Sayfa', ROLL: 'Rulo' },
  versionStatuses: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    APPROVED: 'Onaylandı',
    ARCHIVED: 'Arşivlendi',
  },
  printKinds: { TEST: 'Test baskısı', PRODUCTION: 'Üretim baskısı', REPRINT: 'Yeniden baskı' },
  printStatuses: { PENDING: 'İşleniyor', READY: 'Hazır', FAILED: 'Başarısız' },
  elementTypes: {
    TEXT: 'Metin',
    DYNAMIC_TEXT: 'Dinamik metin',
    BARCODE: 'Barkod',
    QR_CODE: 'QR kodu',
    LINE: 'Çizgi',
    BOX: 'Çerçeve',
  },
  dynamicFields: {
    product: {
      number: 'Ürün numarası',
      ean: 'EAN / GTIN',
      name: 'Ürün adı',
      externalName: 'Harici ad',
      declarationName: 'Beyan adı',
    },
    declaration: {
      productName: 'Yasal ürün adı',
      ingredients: 'İçindekiler listesi',
      allergens: 'Alerjenler',
      additives: 'Katkı maddeleri',
      warnings: 'Uyarılar',
    },
    nutrition: { summary: 'Besin özeti' },
    analysis: { value: 'Analiz değeri' },
    batch: {
      number: 'Parti numarası',
      bestBeforeDate: 'Tavsiye edilen tüketim tarihi',
      expiryDate: 'Son tüketim tarihi',
      productionDate: 'Üretim tarihi',
    },
    productionOrder: { number: 'Üretim emri numarası' },
    quantity: { value: 'Miktar', unit: 'Birim' },
    storage: { instructions: 'Saklama talimatları' },
  },
  actions: {
    ...labelsEn.actions,
    addElement: 'Öğe ekle',
    moveUp: 'Yukarı taşı',
    moveDown: 'Aşağı taşı',
    newVersion: 'Yeni sürüm',
    submit: 'İncelemeye gönder',
    approve: 'Onayla',
    archive: 'Arşivle',
    preview: 'Önizleme',
    testPrint: 'Test baskısı',
    productionPrint: 'Üretim baskısı',
    download: 'PDF aç',
    reprint: 'Yeniden bas',
  },
  transition: {
    submit: {
      title: 'İncelemeye gönder',
      description: 'İnceleme sırasında düzen değişikliklere kilitlenir.',
    },
    approve: {
      title: 'Etiketi onayla',
      description: 'Dört göz onayı, üretim baskıları için sürümü dondurur.',
    },
    archive: {
      title: 'Sürümü arşivle',
      description: 'Arşivlenen sürümler ve baskı kanıtları değiştirilemez olarak kalır.',
    },
  },
  copy: {
    title: 'Yeni sürüm oluştur',
    description: 'Seçilen sürüm, düzenlenebilir yeni bir taslağa kopyalanır.',
  },
  reprint: {
    title: 'Gerekçeli yeniden baskı',
    description:
      'Geçmiş sürüm ve veri anlık görüntüsü aynen yeniden kullanılır. Yeni baskının nedenini belirtin.',
  },
  messages: {
    ...labelsEn.messages,
    invalid: 'Girilen verileri kontrol edin.',
    formatSaved: 'Format kaydedildi.',
    templateCreated: 'Şablon oluşturuldu.',
    saved: 'Taslak kaydedildi.',
    submit: 'Sürüm incelemeye gönderildi.',
    approve: 'Sürüm onaylandı.',
    archive: 'Sürüm arşivlendi.',
    versionCreated: 'Yeni bir taslak sürümü oluşturuldu.',
    printCreated: '{{number}} numaralı baskı oluşturuldu.',
    reprintCreated: 'Yeniden baskı kaydedildi.',
    productRequired: 'Önce bir ürün seçin.',
    loadFailed: 'Etiket şablonu yüklenemedi.',
  },
} as const;
